import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import translations from 'services/translations/translations';

import 'style/layout/forms/SelectInputTranslated.css';

const SelectInputTranslated = ({
  className,
  disabled,
  id,
  label,
  name,
  onChange,
  optionKeyBase,
  options,
  required,
  translationPath,
  value,
}: {
  className?: string;
  disabled?: boolean;
  id?: string;
  label?: string;
  name?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  optionKeyBase: string;
  options: string[];
  required?: boolean;
  translationPath?: string;
  value: string;
}): JSX.Element => {
  const { t } = useTranslation([translations.common]);

  const getClassName = () =>
    className === undefined ? 'text-field' : `text-field ${className}`;

  const getTranslation = (option: string) =>
    translationPath === undefined ? option : t(`${translationPath}:${option}`);

  return (
    <FormGroup className="select-input-translated">
      {label === undefined ? null : (
        <Label className="label" for={id}>
          {label}
        </Label>
      )}
      <Input
        className={getClassName()}
        disabled={disabled}
        id={id}
        name={name}
        required={required && value === ''}
        onChange={onChange}
        type="select"
        value={value}
      >
        {options.map((option) =>
          option === '' ? (
            <option key={`${optionKeyBase}-empty`} value="">
              -
            </option>
          ) : (
            <option key={`${optionKeyBase}-${option}`} value={option}>
              {getTranslation(option)}
            </option>
          )
        )}
      </Input>
    </FormGroup>
  );
};

export default SelectInputTranslated;
